import { schema } from 'normalizr';

const organization = new schema.Entity('organization');

export default organization;
